module.exports = __webpack_public_path__ + "static/media/SpaceScheduling.ce81b3f3.pdf";